import React from "react";
import "./FreeEstimateBanner.css";

/**
 * Props:
 * - bgSrc: right-side background image (keys). Default: /invert.jpg (put in /public)
 * - eyebrow, title, body, ctaText
 * - onCtaClick: click handler for the CTA (e.g., () => window.location.assign('tel:+1206xxxxxxx'))
 */
export default function FreeEstimateBanner({
  bgSrc = `${process.env.PUBLIC_URL}/invert.jpg`,
  eyebrow = "Ready to Get Started?",
  // Client request: remove the word "Free"
  title = "Request an Appraisal Estimate",
  body = "Emerald Appraisal Services provides certified residential valuations across Pierce, King, Thurston, Kitsap, Lewis, Mason, Grays Harbor and Snohomish counties. Whether for purchases, refinances, estate settlements, divorce and separation, or pre-listing, get a clear, no-obligation estimate and timeline today.",
  ctaText = "Call Now",
  onCtaClick = () => (window.location.href = "/contact"),
}) {
  return (
    <section className="fe" aria-labelledby="fe-title">
      {/* Background layers */}
      <div className="fe__bg" aria-hidden="true">
        <img
          src={bgSrc}
          alt=""
          className="fe__bg-img"
          width={1920}
          height={600}
          loading="eager"
          decoding="async"
        />
        <div className="fe__bg-overlay" />
        <div className="fe__bg-pattern" />
      </div>

      {/* Content */}
      <div className="fe__container">
        <div className="fe__content">
          <p className="fe__eyebrow">{eyebrow}</p>
          <h2 id="fe-title" className="fe__title">{title}</h2>
          <p className="fe__text">{body}</p>

          <button
            className="fe__cta"
            onClick={onCtaClick}
            aria-label={ctaText}
            type="button"
          >
            <span>{ctaText}</span>
            <svg
              className="fe__cta-icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path 
                d="M4.167 6.667c1.241-1.585 3.07-2.5 5-2.5 3.682 0 6.666 2.984 6.666 6.666s-2.984 6.667-6.666 6.667c-1.93 0-3.76-.915-5-2.5M10 10h5" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
